import type { ReactNode } from "react";

export function PageContainer({ children }: { children: ReactNode }) {
  return <div className="min-h-full px-4 py-5 sm:px-6 lg:px-9 lg:py-8 animate-pageIn">{children}</div>;
}
